import React from 'react';

import { hideIntro } from '../actions/settings'

import ReadMore from './read-more';
import Settings from './settings';

class Intro extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      readMore: false,
    };
  }

  render() {
    const { state, props } = this;
    const { showIntro } = props.settings;

    if (state.readMore) {
      return <ReadMore onClickBack={() => this.setState({ readMore: false })} />
    }

    if (!showIntro) {
      return <Settings {...props} />
    };

    return (
      <div className="intro view">
        <h1>calculon</h1>

        <p>Calculon keeps track of how many drinks you've had and when it's safe for you to breastfeed.</p>

        <p>Calculon uses <b>Australian Standard Drinks</b> and its calculations are based on studies by Ho et al (2001) and Giglia & Binns (2006).</p>
        <button
          className="btn tertiary"
          onClick={() => this.setState({ readMore: true })}
        >Read more</button>

        <p>
          <button
            className="btn"
            onClick={hideIntro}
          >Let's get started</button>
        </p>
    </div>
    )
  }
}

export default Intro;



// WEBPACK FOOTER //
// ./src/components/intro.js